import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { cacheDom } from "../../utils/QuerySelectors.js"
import { setOpen, setJson, setSelectedId, setHoverId } from '../store/lookSlice.js'
import Look from "./Look.jsx"

const dom = {}
const qs = {
}
const qsAll = {
}

const Container = (data) => {
  const looks = data.data
  const dispatch = useDispatch()
  const { open, json, selectedId, hoverId } = useSelector((state) => state.look)
  console.log('open', looks, open, json, selectedId, hoverId)

  cacheDom(dom, qs, qsAll)
  useEffect(() => {
    const newPath = `${Shopify.routes.root}pages/shop-the-look/${json?.subpath}?look=${selectedId}`               
    if(location.href != newPath) {
      history.pushState({}, "", newPath)
    }
    
    window.setupApiTiles(document, () => {
      setTimeout(() => {
        window.setupQuickAdds(document)
      }, 500)
    })
  }, [selectedId])

  const stateSetSelectedId = (newId) => {
    dispatch(setSelectedId(newId))
  }

  const stateSetOpen = (newOpen) => {
    dispatch(setOpen(newOpen))
  }

  return (
    <div className='lg:flex gap-10'>
      {
        !hoverId && !!selectedId && !!json?.looks[selectedId - 1]?.image && 
        <img
          className='w-full lg:h-[calc(100vh-4rem)] lg:w-auto block lg:sticky lg:top-[4.125rem] mb-10 lg:mb-0 cursor-pointer' 
          src={json.looks[selectedId - 1]?.image} 
          alt={`Look ${selectedId} Image`}
          onClick={e => {
            dispatch(setHoverId(null))
            dispatch(setOpen(true))
          }} 
          />
      }
      {
        !!hoverId && !!json?.looks[hoverId - 1]?.image && 
        <img
          className='w-full lg:h-[calc(100vh-4rem)] lg:w-auto block lg:sticky lg:top-[4.125rem] mb-10 lg:mb-0' 
          src={json.looks[hoverId - 1]?.image} 
          alt={`Look ${hoverId} Image`} 
          />
      }
      {
        !open &&
        <div className='grow grid grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4 lg:gap-10'>
          {
            json?.looks?.map((look, index) =>
              <div>
                <a key={`${json?.subpath}-${index}`}
                  className='group relative'
                  href={`${Shopify.routes.root}pages/shop-the-look/${json?.subpath}?look=${index + 1}`}
                  onClick={e => {
                    e.preventDefault()
                    // const newPath = e.target.className == 'A' ? e.target.href : e.target.closest('a')?.href
                    
                    // if(location.href != newPath) {
                    //   history.pushState({}, "", newPath)
                    // }
                    dispatch(setHoverId(null))
                    dispatch(setSelectedId(index + 1))
                    dispatch(setOpen(true))
                  }}
                  onMouseEnter={e => {
                    dispatch(setHoverId(index + 1))
                  }}
                  onMouseLeave={e => {
                    dispatch(setHoverId(null))
                  }}
                >
                  <img
                    className={`w-full block group-hover:opacity-0 transition-opacity duuration-300 ease-in-out ${selectedId == index + 1 ? 'opacity-0' : ''}`} 
                    src={look.image} 
                    alt={`Look ${index + 1} Image`} 
                  />
                  <span className={`absolute opacity-0 group-hover:opacity-100 transition-opacity duuration-300 ease-in-out inset-0 flex items-center justify-center ${selectedId == index + 1 ? '!opacity-100' : ''}`}>
                    {window.secondStrings.shopTheLook.look} {index + 1}
                  </span>
                </a>
              </div>
            )
          }
          
        </div> 
      }
      {
        !!open && !!selectedId && !!json &&
        <Look 
          selectedId={selectedId}
          json={json}
          setSelectedId={stateSetSelectedId}
          setOpen={stateSetOpen} 
        /> 
      }
    </div>
  )
}

export default Container